export const url = 'https://api.confusability.ai/'
